import React from "react";

const ErrorMessage = (props) => {
	return <div className="error-message">{props.errMsg}</div>;
};

export default ErrorMessage;
